import { CUSTOMERS, NODES, ROADS } from './data';
import type { DevelopmentPlan, Hypotheses } from './types';

// Temporal reachability on the demonstration graph; manual geometry has no approved validation rule.
export function phasingWarnings(plan: DevelopmentPlan, hypotheses: Hypotheses): string[] {
  if (!plan.snapshot) return [];
  const warnings: string[] = [];
  Object.entries(plan.subscribers).forEach(([id, month]) => {
    if (!month) return;
    const customer = CUSTOMERS.find(c => c.id === id);
    if (!customer) return;
    const reachable = new Set<number>();
    hypotheses.departures.forEach(d => {
      const road = ROADS.find(r => r.id === d.roadId);
      if (!road) return;
      if (d.kind === 'network') { reachable.add(road.from); reachable.add(road.to); }
      else {
        const end = d.coordinates[d.coordinates.length - 1];
        const a = NODES[road.from], b = NODES[road.to];
        reachable.add(Math.hypot(a[0] - end[0], a[1] - end[1]) <= Math.hypot(b[0] - end[0], b[1] - end[1]) ? road.from : road.to);
      }
    });
    let changed = true;
    while (changed) {
      changed = false;
      plan.pipes.filter(p => !p.manual && p.month && p.month <= month).forEach(p => {
        const road = ROADS.find(r => r.id === p.roadId);
        if (!road || (!reachable.has(road.from) && !reachable.has(road.to))) return;
        if (!reachable.has(road.from) || !reachable.has(road.to)) changed = true;
        reachable.add(road.from); reachable.add(road.to);
      });
    }
    if (!reachable.has(customer.node)) warnings.push(`${customer.name} : aucune desserte entièrement réalisée en ${month.slice(5)}/${month.slice(0, 4)}.`);
  });
  return warnings;
}
